import { fetchBootData } from '../../api/boot'
import { MUTATION_TYPES as ACTOR_RELATIONSHIP_MUTATION_TYPES } from './actor-relationships'
import { MUTATION_TYPES as COMMUNITY_MUTATION_TYPES } from './communities'
import { MUTATION_TYPES as SPOTTING_AREAS_MUTATION_TYPES } from './spottingareas'

export const ACTION_TYPES = {
  FETCH_BOOT_DATA: 'BOOT/FETCH_BOOT_DATA',
}

export const actions = {
  [ACTION_TYPES.FETCH_BOOT_DATA] ({ commit }) {
    return fetchBootData()
      .then(response => {
        if (response.relationships) {
          commit(ACTOR_RELATIONSHIP_MUTATION_TYPES.UPDATE_RELATIONSHIPS, response.relationships)
        }

        if (response.spottingAreaHighlight && response.spottingAreaHighlight.id) {
          commit(SPOTTING_AREAS_MUTATION_TYPES.FETCH_SPOTTING_AREA_HIGHLIGHT_SUCCESS, response.spottingAreaHighlight)
        }

        if (response.communities) {
          commit(COMMUNITY_MUTATION_TYPES.FETCH_COMMUNITIES_LIST_SUCCESS, response.communities)
        }

        if (response.spottingAreas) {
          commit(SPOTTING_AREAS_MUTATION_TYPES.FETCH_SPOTTING_AREAS_LIST_SUCCESS, response.spottingAreas)
        }
      })
      .catch(err => {
        console.error('Boot data fetch failed:', err)
      })
  },
}

export default {
  actions,
}
